
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M15.536 2.807a3 3 0 014.242 0l1.414 1.415a3 3 0 010 4.242L9.88 19.778a1 1 0 01-.566.283l-4.95.707a1 1 0 01-1.131-1.131l.707-4.95a1 1 0 01.283-.566L15.536 2.807zm2.828 1.415a1 1 0 00-1.414 0L5.872 15.3 5.4 18.6l3.3-.472L19.778 7.05a1 1 0 000-1.414l-1.414-1.414z","clip-rule":"evenodd"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      